module.exports = __webpack_public_path__ + "static/media/cleo-desktop-1220x150.ebbcf211.webp";